import { transport } from 'config/transport';

export function callApiUnRegisterSubjects(congDoanId, classId, dangKyBody) {
    return transport.del(`/mamnon/${congDoanId}/thuhocsinh/${classId}/dangky/unregister`, { data: dangKyBody });
}
